import { createContext, useContext, useReducer } from 'react';

const TabDataContext = createContext(null);
const TabDataDispatchContext = createContext(null);

export const TabDataProvider = ({ children }) => {
	const [tabDataState, dispatch] = useReducer(tabDataReducer, initialState);

	return (
		<TabDataContext.Provider value={tabDataState}>
			<TabDataDispatchContext.Provider value={dispatch}>
				{children}
			</TabDataDispatchContext.Provider>
		</TabDataContext.Provider>
	);
};

export const useTabDataState = () => useContext(TabDataContext);
export const useTabDataDispatch = () => useContext(TabDataDispatchContext);

export const TabActions = {
	CUSTOM_MAPS_TAB: {
		SELECT_FILE: 'customMapsSelectFile',
		SET_HEADER_AND_ROWS: 'customMapsSetHeaderAndRows',
		RESET: 'customMapsReset',
		SET_PAGE: 'customMapsTabSetPage',
		SET_TOTAL_PAGE: 'customMapsTabSetTotalPage',
		SET_SEARCH_TEXT: 'customMapsTabSetSearchText',
		SET_MAP_TYPE: 'customMapsTabSetMapType',
		SET_SHOW_MODAL: 'customMapsTabSetShowModal',
		SET_CURRENT_MAPS: 'customMapsTabSetCurrentMaps',
		SET_SELECTED_MAP_FOR_CREATE: 'customMapsTabSetSelectedMapForCreate',
		SET_MAP_MODAL_TYPE: 'customMapsTabSetMapModalType',
		SET_SHOW_CLONE_CONVERT_MODAL: 'customMapsTabSetShowCloneConvertModal',
		SET_MAP_TO_DELETE: 'customMapsSetMapToDelete',
		CUSTOM_MAPS_DATA_SET_NAME: 'customMapsDataSetName',
		CUSTOM_MAPS_DATA_SET_MAP_TYPE: 'customMapsDataSetMapType',
		CUSTOM_MAPS_DATA_SET_CLIENT_ID: 'customMapsDataSetClientId',
		CUSTOM_MAPS_DATA_SET_CLIENT_NAME: 'customMapsDataSetClientName',
		CUSTOM_MAPS_DATA_SET_FORCE_RELOAD: 'customMapsDataSetForceReload',
		CUSTOM_MAPS_DATA_SET_NAME_MAP_TYPE_CLIENT_ID:
			'customMapsCustomMapsDataSetNameMapTypeClientId',
		CUSTOM_MAPS_DATA_RESET: 'customMapsTabCustomMapsDataReset'
	},
	IMPORT_TAB: {
		SELECT_FILE: 'importTabSelectFile',
		SET_HEADER_AND_ROWS: 'importTabSetHeaderAndRows',
		RESET: 'importTabReset',
		SET_IS_MULTISHEET: 'importTabMultisheet',
		UPDATE_MULTISHEET: 'importTabUpdate-multisheet',
		SET_SELECTED_MULTISHEET: 'importTabSelected-multisheet',
		SET_PAGE: 'importTabSetPage',
		SET_TOTAL_PAGE: 'importTabSetTotalPage',
		SET_SEARCH_TEXT: 'importTabSetSearchText',
		SET_MAP_TYPE: 'importTabSetMapType',
		SET_SHOW_MODAL: 'importTabSetShowModal',
		SET_CURRENT_MAPS: 'importTabSetCurrentMaps',
		SET_SELECTED_MAP_FOR_CREATE: 'importTabSetSelectedMapForCreate',
		SET_MAP_MODAL_TYPE: 'importTabSetMapModalType',
		SET_SHOW_CLONE_CONVERT_MODAL: 'importTabSetShowCloneConvertModal',
		SET_CURRENT_SELECTED_MAP: 'importTabSetCurrentSelectedMap',
		SET_MAP_TO_DELETE: 'importTabSetMapToDelete',
		CUSTOM_MAPS_DATA_SET_NAME: 'importTabCustomMapsDataSetName',
		CUSTOM_MAPS_DATA_SET_MAP_TYPE: 'importTabCustomMapsDataSetMapType',
		CUSTOM_MAPS_DATA_SET_CLIENT_ID: 'importTabCustomMapsDataSetClientId',
		CUSTOM_MAPS_DATA_SET_CLIENT_NAME: 'importTabCustomMapsDataSetClientName',
		CUSTOM_MAPS_DATA_SET_FORCE_RELOAD: 'importTabCustomMapsDataSetForceReload',
		CUSTOM_MAPS_DATA_SET_NAME_MAP_TYPE_CLIENT_ID:
			'importTabCustomMapsDataSetNameMapTypeClientId',
		CUSTOM_MAPS_DATA_RESET: 'importTabCustomMapsDataReset',
		SET_SKIP_TAXES: 'importTabSetSkipTaxes',
		SET_DISABLE_CANCEL: 'importTabSetDisableCancel',
		SET_SHOW_SKIP_MODAL: 'importTabSetShowSkipModal'
	},
	STANDARD_MAP_TEMPLATES_TAB: {
		SELECT_FILE: 'mapTemplatesTabSelectFile',
		SET_PAGE: 'mapTemplatesTabSetPage',
		SET_SEARCH_TEXT: 'mapTemplatesTabSetSearchText',
		SET_CURRENT_MAPS: 'mapTemplatesTabSetCurrentMaps',
		SET_TOTAL_PAGE: 'mapTemplatesTabSetTotalPage',
		RESET: 'mapTemplatesTabReset',
		SET_HEADER_AND_ROWS: 'mapTemplatesSetHeaderAndRows',
		SET_SELECTED: 'mapTemplatesSetSelected'
	},
	REGISTRATION_TAB: {
		SET_MODAL: 'registrationTabsetModal',
		UPDATE_DELETE_MODAL: 'registrationTabUpdateDeleteModal',
		RESET_SELECTED_REGISTRATION: 'registrationTabResetSelectedRegistration',
		SET_SHOW_POPUP: 'registrationTabSetShowPopup',
		SET_DOCUMENT_TITLE: 'registrationTabSetDocumentTitle',
		SET_DOCUMENT_VERSION: 'registrationTabSetDocumentVersion',
		SET_TEAM_NAME: 'registrationTabSetTeamName',
		SET_SUPPORT_TEAM_EMAIL: 'registrationTabSetSupportTeamEmail',
		SET_MAP_NAMES: 'registrationTabSetMapNames',
		SET_SWAGGER_DOCUMENT: 'registrationTabSetSwaggerDocument',
		RESET_FORM_DATA_ERRORS: 'registrationTabreSetFormDataErrors',
		SET_FORM_DATA_ERRORS_TITLE: 'registrationTabSetFormDataErrorsTitle',
		SET_FORM_DATA_ERRORS_VERSION: 'registrationTabSetFormDataErrorsVersion',
		SET_FORM_DATA_ERRORS_TEAM: 'registrationTabSetFormDataErrorsTeam',
		SET_FORM_DATA_ERRORS_EMAIL: 'registrationTabSetFormDataErrorsEmail',
		SET_FORM_DATA_ERRORS_SWAGGER: 'registrationTabSetFormDataErrorsSwagger',
		SET_PAGE: 'registrationTabSetPage',
		SET_TOTAL_PAGE: 'registrationTabSetTotalPage',
		RESET: 'registrationTabTabReset',
		SET_SEARCH_TEXT: 'registrationTabSetSearchText'
	},
	ALIAS_TAB: {
		SET_ITEMS_COUNT: 'aliasSetItemsCount',
		SET_IS_LOAD_MORE_DISABLED: 'setIsLoadMoreDisabled',
		SET_INVALID_CLIENTID: 'setInvalidClientId',
		SET_DISABLE_ADDBTN: 'setDisableAddBtn',
		SET_ALIAS_DATA: 'setAliasData',
		SET_DISPLAY_CLIENTNOTFOUND: 'setDisplayClientNotFound',
		SET_SHOW_ADDALIAS: 'setShowAddAlias',
		SET_ALIAS_CLIENTID: 'setAliasClientId',
		SET_ALIAS_TYPE: 'setAliasType',
		SET_ALIAS_KEY: 'setAliasKey',
		SET_ALIAS_VALUE: 'setAliasValue',
		SET_CLIENT_NAME: 'setClientName',
		SET_RELOAD_GRID_TOGGLE: 'setReloadGridToggle',
		SET_SHOW_GRID: 'setShowGrid',
		SET_SHOW_MODAL: 'setShowModal',
		SET_ALIASID: 'setAliasId',
		SET_GLOBAL_RADIOCHECKEDSTATUS: 'setGlobalRadioCheckedStatus',
		SET_CLIENT_RADIOCHECKEDSTATUS: 'setClientRadioCheckedStatus',
		CLEAR_INPUTS: 'clearInputs',
		RESET: 'aliasReset'
	},
	ANALYTICS_TAB: {
		SET_DATES: 'analyticsSetDates',
		SET_DATE_FROM: 'analyticsSetDateFrom',
		SET_DATE_TO: 'analyticsSetDateTO',
		SET_DOWNLOAD_LINK: 'analitycsSetDownloadLink',
		RESET: 'analyticsReset'
	},
	MIGRATIONS_TAB: {
		SET_LEGACY_MAP_DATA: 'migrationTabSetLegacyMapData',
		SET_MIGRATE_MAP_DATA: 'migrationTabSetMigrateMapData',
		SET_SEARCH_FILTER: 'migrationTabSetSearchFilter',
		SET_PAGE: 'migrationTabSetPage',
		SET_TOTAL_PAGES: 'migrationTabSetTotalPages',
		RESET: 'migrationsReset'
	},
	HISTORY: {
		SET_DATES: 'historySetDates',
		SET_STATUS_FILTER: 'historySetStatusFilter',
		SET_PAGE: 'historySetPage',
		SET_SORTING: 'historySetSorting',
		RESET: 'historyReset',
		SET_HISTORY_TOTAL_PAGES: 'historySetHistoryTotalPages'
	}
};

const tabDataReducer = (state, msg) => {
	switch (msg.action) {
		case TabActions.IMPORT_TAB.SELECT_FILE: {
			return {
				...state,
				importTab: {
					...state.importTab,
					fileName: msg.payload.file.name,
					file: msg.payload.file,
					isMultisheet: false
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.CUSTOM_MAPS_DATA_SET_NAME:
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					mapName: msg.mapName
				}
			};
		case TabActions.CUSTOM_MAPS_TAB.CUSTOM_MAPS_DATA_SET_MAP_TYPE:
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					mapType: msg.mapType
				}
			};
		case TabActions.CUSTOM_MAPS_TAB.CUSTOM_MAPS_DATA_SET_CLIENT_ID:
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					clientId: msg.clientId
				}
			};
		case TabActions.CUSTOM_MAPS_TAB.CUSTOM_MAPS_DATA_SET_CLIENT_NAME:
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					clientName: msg.clientName
				}
			};
		case TabActions.CUSTOM_MAPS_TAB.CUSTOM_MAPS_DATA_SET_FORCE_RELOAD:
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					forceReload: Date.now()
				}
			};
		case TabActions.CUSTOM_MAPS_TAB.CUSTOM_MAPS_DATA_SET_NAME_MAP_TYPE_CLIENT_ID:
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					mapName: msg.mapName,
					mapType: msg.mapType,
					clientId: msg.clientId
				}
			};
		case TabActions.CUSTOM_MAPS_TAB.CUSTOM_MAPS_DATA_RESET:
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					mapName: '',
					mapType: '',
					clientId: '',
					clientName: ''
				}
			};

		case TabActions.IMPORT_TAB.CUSTOM_MAPS_DATA_SET_NAME:
			return {
				...state,
				importTab: {
					...state.importTab,
					mapName: msg.mapName
				}
			};
		case TabActions.IMPORT_TAB.CUSTOM_MAPS_DATA_SET_MAP_TYPE:
			return {
				...state,
				importTab: {
					...state.importTab,
					mapType: msg.mapType
				}
			};
		case TabActions.IMPORT_TAB.CUSTOM_MAPS_DATA_SET_CLIENT_ID:
			return {
				...state,
				importTab: {
					...state.importTab,
					clientId: msg.clientId
				}
			};
		case TabActions.IMPORT_TAB.CUSTOM_MAPS_DATA_SET_CLIENT_NAME:
			return {
				...state,
				importTab: {
					...state.importTab,
					clientName: msg.clientName
				}
			};
		case TabActions.IMPORT_TAB.CUSTOM_MAPS_DATA_SET_FORCE_RELOAD:
			return {
				...state,
				importTab: {
					...state.importTab,
					forceReload: Date.now()
				}
			};
		case TabActions.IMPORT_TAB.CUSTOM_MAPS_DATA_SET_CLIENT_NAME:
			return {
				...state,
				importTab: {
					...state.importTab,
					clientName: msg.clientName
				}
			};
		case TabActions.IMPORT_TAB.CUSTOM_MAPS_DATA_SET_NAME_MAP_TYPE_CLIENT_ID:
			return {
				...state,
				importTab: {
					...state.importTab,
					mapName: msg.mapName,
					mapType: msg.mapType,
					clientId: msg.clientId
				}
			};
		case TabActions.IMPORT_TAB.CUSTOM_MAPS_DATA_RESET:
			return {
				...state,
				importTab: {
					...state.importTab,
					mapName: '',
					mapType: '',
					clientId: '',
					clientName: ''
				}
			};
		case TabActions.CUSTOM_MAPS_TAB.SELECT_FILE: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					fileName: msg.payload.file.name,
					file: msg.payload.file
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_HEADER_AND_ROWS: {
			return {
				...state,
				importTab: {
					...state.importTab,
					headersAndRows: msg.payload.headersAndRows,
					isSelected: true
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_HEADER_AND_ROWS: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					headersAndRows: msg.payload.headersAndRows,
					isSelected: true
				}
			};
		}
		case TabActions.IMPORT_TAB.RESET: {
			return {
				...state,
				importTab: {
					...initialState.importTab
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.RESET: {
			return {
				...state,
				customMapsTab: {
					...initialState.customMapsTab
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_IS_MULTISHEET: {
			return {
				...state,
				importTab: {
					...state.importTab,
					isMultisheet: msg.payload.isMultisheet,
					sheetData: msg.payload.sheetData,
					isSelected: true,
					baseMapList: msg.payload.baseMapList
				}
			};
		}
		case TabActions.IMPORT_TAB.UPDATE_MULTISHEET: {
			return {
				...state,
				importTab: {
					...state.importTab,
					selectedMappings: msg.payload.selectedMappings
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_SELECTED_MULTISHEET: {
			return {
				...state,
				importTab: {
					...state.importTab,
					sheetData: msg.payload.sheetData
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_SKIP_TAXES:
			return {
				...state,
				importTab: {
					...state.importTab,
					skipTaxes: msg.payload.skipTaxes
				}
			};
		case TabActions.IMPORT_TAB.SET_DISABLE_CANCEL:
			return {
				...state,
				importTab: {
					...state.importTab,
					disableCancel: msg.payload.disableCancel
				}
			};
		case TabActions.IMPORT_TAB.SET_SHOW_SKIP_MODAL:
			return {
				...state,
				importTab: {
					...state.importTab,
					showSkipModal: msg.payload.showSkipModal
				}
			};
		case TabActions.CUSTOM_MAPS_TAB.SET_PAGE: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					currentPage: {
						...state.customMapsTab.currentPage,
						tempPage: msg.payload.tempPage,
						refreshData: msg.payload.refreshData
					}
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_PAGE: {
			return {
				...state,
				importTab: {
					...state.importTab,
					currentPage: {
						...state.importTab.currentPage,
						tempPage: msg.payload.tempPage,
						refreshData: msg.payload.refreshData
					}
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_TOTAL_PAGE: {
			return {
				...state,
				importTab: {
					...state.importTab,
					totalPages: msg.payload.totalPages
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_TOTAL_PAGE: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					totalPages: msg.payload.totalPages
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_SEARCH_TEXT: {
			return {
				...state,
				importTab: {
					...state.importTab,
					searchFilter: msg.payload.searchText
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_SEARCH_TEXT: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					searchFilter: msg.payload.searchText
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_MAP_TYPE: {
			return {
				...state,
				importTab: {
					...state.importTab,
					mapTypeFilter: msg.payload.mapTypeFilter
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_MAP_TYPE: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					mapTypeFilter: msg.payload.mapTypeFilter
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_SHOW_MODAL: {
			return {
				...state,
				importTab: {
					...state.importTab,
					showModal: msg.payload.showModal
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_SHOW_MODAL: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					showModal: msg.payload.showModal
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_CURRENT_MAPS: {
			return {
				...state,
				importTab: {
					...state.importTab,
					currentMaps: msg.payload.currentMaps
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_CURRENT_MAPS: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					currentMaps: msg.payload.currentMaps
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_SELECTED_MAP_FOR_CREATE: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					selectedMapForCreate: msg.payload.selectedMapForCreate
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_SELECTED_MAP_FOR_CREATE: {
			return {
				...state,
				importTab: {
					...state.importTab,
					selectedMapForCreate: msg.payload.selectedMapForCreate
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_SHOW_CLONE_CONVERT_MODAL: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					showCloneConvertModal: msg.payload.showCloneConvertModal
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_SHOW_CLONE_CONVERT_MODAL: {
			return {
				...state,
				importTab: {
					...state.importTab,
					showCloneConvertModal: msg.payload.showCloneConvertModal
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_MAP_MODAL_TYPE: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					selectedMapForCreate: msg.payload.selectedMapForCreate,
					modalType: msg.payload.modalType,
					showCloneConvertModal: msg.payload.showCloneConvertModal
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_MAP_MODAL_TYPE: {
			return {
				...state,
				importTab: {
					...state.importTab,
					selectedMapForCreate: msg.payload.selectedMapForCreate,
					modalType: msg.payload.modalType,
					showCloneConvertModal: msg.payload.showCloneConvertModal
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_MAP_TO_DELETE: {
			return {
				...state,
				importTab: {
					...state.importTab,
					mapToDelete: msg.payload.mapToDelete
				}
			};
		}
		case TabActions.CUSTOM_MAPS_TAB.SET_MAP_TO_DELETE: {
			return {
				...state,
				customMapsTab: {
					...state.customMapsTab,
					mapToDelete: msg.payload.mapToDelete
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_MODAL: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					modalAction: msg.payload.modalAction,
					modalTitle: msg.payload.modalTitle,
					showPopUp: true
				}
			};
		}
		case TabActions.REGISTRATION_TAB.UPDATE_DELETE_MODAL: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					modalAction: msg.payload.modalAction,
					modalTitle: msg.payload.modalTitle,
					showPopUp: true,
					mapRegistration: msg.payload.registration
				}
			};
		}
		case TabActions.REGISTRATION_TAB.RESET_SELECTED_REGISTRATION: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					mapRegistration: initialState.registrationTab.mapRegistration
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_SHOW_POPUP: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					showPopUp: msg.payload.showPopUp
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_DOCUMENT_TITLE: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					mapRegistration: {
						...state.registrationTab.mapRegistration,
						documentTitle: msg.payload.documentTitle
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_DOCUMENT_VERSION: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					mapRegistration: {
						...state.registrationTab.mapRegistration,
						documentVersion: msg.payload.documentVersion
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_TEAM_NAME: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					mapRegistration: {
						...state.registrationTab.mapRegistration,
						teamName: msg.payload.teamName
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_SUPPORT_TEAM_EMAIL: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					mapRegistration: {
						...state.registrationTab.mapRegistration,
						supportTeamEmail: msg.payload.supportTeamEmail
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_MAP_NAMES: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					mapRegistration: {
						...state.registrationTab.mapRegistration,
						mapNames: msg.payload.mapNames
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_SWAGGER_DOCUMENT: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					mapRegistration: {
						...state.registrationTab.mapRegistration,
						swaggerDocument: msg.payload.swaggerDocument
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.RESET_FORM_DATA_ERRORS: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					formErrors: initialState.registrationTab.formErrors
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_FORM_DATA_ERRORS_TITLE: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					formErrors: {
						...state.registrationTab.formErrors,
						titleError: msg.payload.title
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_FORM_DATA_ERRORS_VERSION: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					formErrors: {
						...state.registrationTab.formErrors,
						version: msg.payload.version
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_FORM_DATA_ERRORS_TEAM: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					formErrors: {
						...state.registrationTab.formErrors,
						team: msg.payload.team
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_FORM_DATA_ERRORS_EMAIL: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					formErrors: {
						...state.registrationTab.formErrors,
						email: msg.payload.email
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_FORM_DATA_ERRORS_SWAGGER: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					formErrors: {
						...state.registrationTab.formErrors,
						swagger: msg.payload.swagger
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_SEARCH_TEXT: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					searchFilter: msg.payload.searchText,
					currentPage: {
						...state.registrationTab.currentPage,
						refreshData: msg.payload.refreshData
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_PAGE: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					currentPage: {
						...state.registrationTab.currentPage,
						tempPage: msg.payload.tempPage,
						refreshData: msg.payload.refreshData
					}
				}
			};
		}
		case TabActions.REGISTRATION_TAB.SET_TOTAL_PAGE: {
			return {
				...state,
				registrationTab: {
					...state.registrationTab,
					totalPages: msg.payload.totalPages
				}
			};
		}
		case TabActions.REGISTRATION_TAB.RESET: {
			return {
				...state,
				registrationTab: {
					...initialState.registrationTab
				}
			};
		}
		case TabActions.IMPORT_TAB.SET_CURRENT_SELECTED_MAP: {
			return {
				...state,
				importTab: {
					...state.importTab,
					currentSelectedMap: msg.payload.currentSelectedMap
				}
			};
		}
		case TabActions.STANDARD_MAP_TEMPLATES_TAB.SET_PAGE: {
			return {
				...state,
				standarMapTemplatesTab: {
					...state.standarMapTemplatesTab,
					currentPage: {
						...state.standarMapTemplatesTab.currentPage,
						tempPage: msg.payload.tempPage,
						refreshData: msg.payload.refreshData
					}
				}
			};
		}
		case TabActions.STANDARD_MAP_TEMPLATES_TAB.SET_TOTAL_PAGE: {
			return {
				...state,
				standarMapTemplatesTab: {
					...state.standarMapTemplatesTab,
					totalPages: msg.payload.totalPages
				}
			};
		}
		case TabActions.STANDARD_MAP_TEMPLATES_TAB.SET_SEARCH_TEXT: {
			return {
				...state,
				standarMapTemplatesTab: {
					...state.standarMapTemplatesTab,
					searchFilter: msg.payload.searchText
				}
			};
		}
		case TabActions.STANDARD_MAP_TEMPLATES_TAB.SET_CURRENT_MAPS: {
			return {
				...state,
				standarMapTemplatesTab: {
					...state.standarMapTemplatesTab,
					currentMaps: msg.payload.currentMaps
				}
			};
		}
		case TabActions.STANDARD_MAP_TEMPLATES_TAB.RESET: {
			return {
				...state,
				standarMapTemplatesTab: {
					...initialState.standarMapTemplatesTab
				}
			};
		}
		case TabActions.STANDARD_MAP_TEMPLATES_TAB.SET_HEADER_AND_ROWS: {
			return {
				...state,
				standarMapTemplatesTab: {
					...state.standarMapTemplatesTab,
					headersAndRows: msg.payload.headersAndRows,
					isSelected: true
				}
			};
		}
		case TabActions.STANDARD_MAP_TEMPLATES_TAB.SET_SELECTED: {
			return {
				...state,
				standarMapTemplatesTab: {
					...state.standarMapTemplatesTab,
					isSelected: true
				}
			};
		}
		case TabActions.STANDARD_MAP_TEMPLATES_TAB.SELECT_FILE: {
			return {
				...state,
				standarMapTemplatesTab: {
					...state.standarMapTemplatesTab,
					fileName: msg.payload.file.name,
					file: msg.payload.file
				}
			};
		}

		case TabActions.ALIAS_TAB.SET_ALIASID: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					aliasId: msg.payload.aliasId
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_ALIAS_CLIENTID: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					aliasClientId: msg.payload.aliasClientId
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_ALIAS_DATA: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					aliasData: msg.payload.aliasData
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_ALIAS_KEY: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					aliasKey: msg.payload.aliasKey
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_ALIAS_TYPE: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					aliasType: msg.payload.aliasType
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_ALIAS_VALUE: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					aliasValue: msg.payload.aliasValue
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_CLIENT_NAME: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					clientName: msg.payload.clientName
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_CLIENT_RADIOCHECKEDSTATUS: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					clientRadioCheckedStatus: msg.payload.clientRadioCheckedStatus
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_DISABLE_ADDBTN: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					disableAddBtn: msg.payload.disableAddBtn
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_DISPLAY_CLIENTNOTFOUND: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					displayClientNotFound: msg.payload.displayClientNotFound
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_GLOBAL_RADIOCHECKEDSTATUS: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					globalRadioCheckedStatus: msg.payload.globalRadioCheckedStatus
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_INVALID_CLIENTID: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					invalidClientId: msg.payload.invalidClientId
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_IS_LOAD_MORE_DISABLED: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					isLoadMoreDisabled: msg.payload.isLoadMoreDisabled
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_ITEMS_COUNT: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					itemsCount: msg.payload.itemsCount
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_RELOAD_GRID_TOGGLE: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					reloadGridToggle: msg.payload.reloadGridToggle
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_SHOW_ADDALIAS: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					showAddAlias: msg.payload.showAddAlias
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_SHOW_GRID: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					showGrid: msg.payload.showGrid
				}
			};
		}
		case TabActions.ALIAS_TAB.SET_SHOW_MODAL: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					showModal: msg.payload.showModal
				}
			};
		}
		case TabActions.ALIAS_TAB.CLEAR_INPUTS: {
			return {
				...state,
				aliasTab: {
					...state.aliasTab,
					showAddAlias: false,
					aliasType: '',
					aliasKey: '',
					aliasValue: '',
					disableAddBtn: false
				}
			};
		}
		case TabActions.ALIAS_TAB.RESET: {
			return {
				...state,
				aliasTab: {
					...initialState.aliasTab
				}
			};
		}

		case TabActions.ANALYTICS_TAB.RESET: {
			return {
				...state,
				analyticsTab: {
					...initialState.analyticsTab
				}
			};
		}
		case TabActions.ANALYTICS_TAB.SET_DATES: {
			return {
				...state,
				analyticsTab: {
					...state.analyticsTab,
					dateFrom: msg.payload.dateFrom,
					dateTo: msg.payload.dateTo
				}
			};
		}

		case TabActions.MIGRATIONS_TAB.RESET: {
			return {
				...state,
				migrationsTab: {
					...initialState.migrationsTab
				}
			};
		}
		case TabActions.MIGRATIONS_TAB.SET_PAGE: {
			return {
				...state,
				migrationsTab: {
					...state.migrationsTab,
					currentPage: {
						...state.migrationsTab.currentPage,
						tempPage: msg.payload.tempPage,
						refreshData: msg.payload.refreshData
					}
				}
			};
		}
		case TabActions.MIGRATIONS_TAB.SET_LEGACY_MAP_DATA: {
			return {
				...state,
				migrationsTab: {
					...state.migrationsTab,
					legacyMapData: msg.payload.legacyMapData
				}
			};
		}
		case TabActions.MIGRATIONS_TAB.SET_MIGRATE_MAP_DATA: {
			return {
				...state,
				migrationsTab: {
					...state.migrationsTab,
					migrateMapData: msg.payload.migrateMapData
				}
			};
		}
		case TabActions.MIGRATIONS_TAB.SET_SEARCH_FILTER: {
			return {
				...state,
				migrationsTab: {
					...state.migrationsTab,
					searchFilter: msg.payload.searchFilter
				}
			};
		}
		case TabActions.MIGRATIONS_TAB.SET_TOTAL_PAGES: {
			return {
				...state,
				migrationsTab: {
					...state.migrationsTab,
					totalPages: msg.payload.totalPages
				}
			};
		}

		case TabActions.HISTORY.SET_DATES: {
			return {
				...state,
				history: {
					...state.history,
					dateFrom: msg.payload.dateFrom,
					dateTo: msg.payload.dateTo,
					refreshData: true
				}
			};
		}
		case TabActions.HISTORY.SET_STATUS_FILTER: {
			return {
				...state,
				history: {
					...state.history,
					statusFilter: msg.payload.statusFilter,
					refreshData: true
				}
			};
		}
		case TabActions.HISTORY.SET_PAGE: {
			return {
				...state,
				history: {
					...state.history,
					page: msg.payload.page,
					refreshData: true
				}
			};
		}
		case TabActions.HISTORY.SET_SORTING: {
			return {
				...state,
				history: {
					...state.history,
					sortingColumn: msg.payload.sortingColumn,
					sortingDirection: msg.payload.sortingDirection,
					refreshData: true
				}
			};
		}
		case TabActions.HISTORY.RESET: {
			return {
				...state,
				history: {
					...initialState.history,
					refreshData: true
				}
			};
		}
		case TabActions.HISTORY.SET_HISTORY_TOTAL_PAGES: {
			let refreshData = false;
			let page = state.history.page;
			//in case the current page is > total history pages (invalid state that breaks UI), we need to reset page and refresh data
			if (
				Boolean(state.history.totalHistoryPages) &&
				state.history.page > msg.payload.totalHistoryPages
			) {
				refreshData = true;
				page = 1;
			}
			return {
				...state,
				history: {
					...state.history,
					totalHistoryPages: msg.payload.totalHistoryPages,
					page: page,
					refreshData: refreshData
				}
			};
		}
		default: {
			console.warn('tabDataReducer: Encountered an unknown reducer action', msg);
		}
	}
};

const addToCurrentDate = (numberOfDays) => {
	let currentDate = new Date();
	let addDays = currentDate.getDate() + numberOfDays;
	return new Date(currentDate.setDate(addDays));
};

const initialState = {
	importTab: {
		fileName: '',
		file: {},
		headersAndRows: '',
		isSelected: false,
		isMultisheet: false,
		sheetData: [],
		baseMapList: [],
		selectedMappings: [],
		currentPage: {
			tempPage: 1,
			refreshData: false
		},
		totalPages: 1,
		searchFilter: '',
		mapTypeFilter: '',
		showModal: false,
		currentMaps: [],
		selectedMapForCreate: {},
		modalType: 'clone',
		showCloneConvertModal: false,
		currentSelectedMap: {},
		mapName: '',
		mapType: '',
		clientId: '',
		clientName: '',
		forceReload: null,
		mapToDelete: {},
		skipTaxes: false,
		disableCancel: false,
		showSkipModal: false
	},
	customMapsTab: {
		fileName: '',
		file: {},
		headersAndRows: '',
		isSelected: false,
		sheetData: [],
		currentPage: {
			tempPage: 1,
			refreshData: false
		},
		totalPages: 1,
		searchFilter: '',
		mapTypeFilter: '',
		showModal: false,
		currentMaps: [],
		selectedMapForCreate: {},
		modalType: 'clone',
		showCloneConvertModal: false,
		mapName: '',
		mapType: '',
		clientId: '',
		clientName: '',
		forceReload: null,
		mapToDelete: {}
	},
	standarMapTemplatesTab: {
		fileName: '',
		file: {},
		headersAndRows: '',
		isSelected: false,
		currentPage: {
			tempPage: 1,
			refreshData: false
		},
		totalPages: 1,
		searchFilter: '',
		currentMaps: [],
		currentSelectedMap: {}
	},
	registrationTab: {
		mapRegistration: {
			mappingRegistrationId: null,
			teamName: '',
			documentVersion: '',
			documentTitle: '',
			supportTeamEmail: '',
			mapNames: '',
			swaggerDocument: ''
		},
		formErrors: {
			titleError: null,
			version: null,
			email: null,
			team: null,
			swagger: null
		},
		currentPage: {
			tempPage: 1,
			refreshData: false
		},
		totalPages: 1,
		showModal: false,
		showPopUp: false,
		modalTitle: '',
		modalAction: '',
		searchFilter: ''
	},
	aliasTab: {
		invalidClientId: false,
		isLoadMoreDisabled: false,
		itemsCount: 5,
		disableAddBtn: false,
		aliasData: [],
		displayClientNotFound: false,
		showAddAlias: false,
		aliasClientId: undefined,
		aliasType: '',
		aliasKey: '',
		aliasValue: '',
		clientName: '',
		reloadGridToggle: false,
		showGrid: false,
		showModal: false,
		aliasId: '',
		globalRadioCheckedStatus: true,
		clientRadioCheckedStatus: false
	},
	analyticsTab: {
		dateFrom: addToCurrentDate(-30),
		dateTo: new Date()
	},
	migrationsTab: {
		legacyMapData: [],
		migrateMapData: [],
		currentPage: {
			tempPage: 1,
			refreshData: false
		},
		totalPages: 1,
		searchFilter: ''
	},
	history: {
		refreshData: false,
		dateFrom: addToCurrentDate(-30),
		dateTo: new Date(),
		statusFilter: 'all',
		sortingColumn: 'importStartTime',
		sortingDirection: 'desc',
		totalHistoryPages: 1,
		page: 1
	}
};
